module.exports = __webpack_public_path__ + "img/neck1.6a06fa8b.jpg";